import {
  Backdrop, Button, Card, CardActions, createMuiTheme, CardContent, CardHeader, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogTitle, Divider,
  FormControl, Grid, InputAdornment, LinearProgress, Slide, Snackbar, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography
} from '@material-ui/core';
import { SearchIcon } from '@material-ui/data-grid';
import CloseIcon from '@material-ui/icons/Close';
import FindInPageIcon from '@material-ui/icons/FindInPage';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import MuiAlert from '@material-ui/lab/Alert';
import trLocale from 'date-fns/locale/tr';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import React, { useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import GenericBulten from 'src/components/GenericBulletin';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment';
import {
  getUser,
  sc,

} from 'src/utils/Common';

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  cardUstBolum: {
    maxHeight: 700,
    minHeight: 700,
    width: '100%'
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  container: {
    maxHeight: 497,
    minHeight: 497,
    mimWidth: 500
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  rootAdresSearch: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(0)
  },
}));

const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FF9800',
      dark: '#424242',
      main: '#424242',
      light: '#424242'
    }
  }
});
const localeMap = {
  tr: trLocale
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Counting() {
  const classes = useStyles();
  const [uyariAciklama, setUyariAciklama] = useState('');
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = useState();
  const [LoadingMaterial, setLoadingMaterial] = React.useState(true);
  const [bultenOpen, setBultenOpen] = React.useState(false);
  const [bultenParam, setBultenParam] = React.useState('');
  const [openMaterialFileTitle, setOpenMaterialFileTitle] = React.useState('');
  const [openMaterialFile, setOpenMaterialFile] = React.useState(false);
  const [ImageUrl, setImageUrl] = useState(null);
  const [Loading, setLoading] = useState(false);
  const SessionUser = getUser();
  const [SayimData, setSayimData] = useState([]);
  const [SayimDataMain, setSayimDataMain] = useState([]);
  const [SayimArama, setSayimArama] = React.useState("");
  const [MalzemeEkle, setMalzemeEkle] = React.useState("");
  const [Adresrow, setAdresrow] = useState([{ WarehouseAddress: 0, WarehouseAddressText: '', Malzemeleri: '' }]);
  const today = moment(new Date()).format('YYYY-MM-DD');
  const [baslangicTarihi, setBaslangicTarihi] = useState(today);
  const [bitisTarihi, setBitisTarihi] = useState(today);

  const handleDateChange = (event, type) => {
    var Deger = moment(event).format('YYYY-MM-DD');
    type === 1 ? setBaslangicTarihi(Deger) : setBitisTarihi(Deger);
  };

  const handleCloseMaterialFile = () => {
    setOpenMaterialFile(false);
  };
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };

  const GetMaterialBulletin = (event, materialCode) => {
    setBultenParam(materialCode);
    setBultenOpen(true);
    setLoadingMaterial(false);
  };

  const GetMaterialImage = (event, materialCode) => {
    setOpenMaterialFile(true);
    setLoadingMaterial(true);
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    setOpenMaterialFileTitle(materialCode + ' Numaralı Malzeme Detayı');
    axios
      .get(`MaterialFile/${materialCode}`, config)
      .then(response => {
        var fileURL = URL.createObjectURL(response.data);
        setImageUrl(fileURL);
        setLoadingMaterial(false);
      })
      .catch(error => {
        setLoadingMaterial(false);
      });
  };

  function onSorgula() {
    setLoading(true);
    axios
      .get(
        `/GetCountingDifferenceMaterial/${SessionUser.ServiceShopId}/${baslangicTarihi}/${bitisTarihi}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          setSayimData(response.data);
          setSayimDataMain(response.data);
        } else {
          setSayimData([]);
          setSayimDataMain([]);
        }
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
        setSayimData([]);
        setSayimDataMain([]);
      });
  }

  const setMaterialResetAccept = () => {
    setLoading(true);
    axios
      .get(
        `/SetMaterialReset/${SessionUser.ServiceShopId}/${SessionUser.OrganizationUserId}/${MalzemeEkle}`
      )
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {

        } else {

        }
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const setMaterialReset = () => {

    if (MalzemeEkle.length < 1) {
      return;
    }


    confirmAlert({
      message: MalzemeEkle + " numaralı malzemeyi sıfırlamak isteğinizden emin misiniz?",
      buttons: [
        {
          label: 'Evet',
          onClick: () => setMaterialResetAccept()
        },
        {
          label: 'Hayır',
          onClick: () => {
            return;
          }
        }
      ]
    });

  }


  const setFilter = (Param) => {
    setSayimArama(Param);
    setSayimData(SayimDataMain.filter(item => sc(item.MALZEME_STOK_NO, Param) || sc(item.MALZEME, Param) || sc(item.WarehouseAddressText, Param) || sc(item.KULLANICI, Param)))
  };

  const search = "";

  const setAdres = (param, index, MALZEME_STOK_NO) => {

    let old_rows = [...SayimData];
    old_rows[index].WarehouseAddress = param?.Id || 0;
    old_rows[index].WarehouseAddressText = param?.Description || 0;
    old_rows[index].Malzemeleri = param?.Materials || 0;
    setSayimData(old_rows);

  }
  const setAdresEkle = (param, index, MALZEME_STOK_NO) => {
    let old_rows = [...Adresrow];
    console.log(old_rows);
    old_rows[0].WarehouseAddress = param?.Id || 0;
    old_rows[0].WarehouseAddressText = param?.Description || 0;
    old_rows[0].Malzemeleri = param?.Materials || 0;
    console.log(old_rows);
    setAdresrow(old_rows);
  }

  const MalzemeSayimEkle = () => {





    setLoading(true);
    var AdresId = Adresrow[0].WarehouseAddress;
    axios
      .get(`/SetMaterialCountingAdd/${MalzemeEkle}/${AdresId}/${SessionUser.ServiceShopId}/${SessionUser.OrganizationUserId}`)
      .then(response => {
        if (response.data.toString() === 'Basarili') {
          onSorgula();
          setMalzemeEkle("");
        } else {
          setUyariTip('error');
          setUyariAciklama(response.data);
          setUyari(true);
        }
        setLoading(false);
      })
      .catch(error => {
        onSorgula();
        setLoading(false);
      });
  };

    

  return (
    <Page className={classes.root} title="oasis Yönetimi">
      <Container maxWidth="xl">
        <Card>
          <CardHeader title="Oasis Yönetimi Sayım Fark Raporu" />
          <Divider />
          <Backdrop className={classes.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          <Snackbar open={uyari} autoHideDuration={6000}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            onClose={uyariKapat}>
            <Alert onClose={uyariKapat} severity={uyariTip}>
              {uyariAciklama || ''}
            </Alert>
          </Snackbar>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={12}>
                <Card className={classes.cardUstBolum}>
                  <CardHeader
                    title="İşlemler"
                    action={
                      <Grid container spacing={1}>

                      </Grid>
                    }
                  />
                  <Divider />
                  <CardActions>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={3} title={"Başlangıç tarihi"} >
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider
                                utils={DateFnsUtils}
                                locale={localeMap['tr']}
                              >
                                <KeyboardDatePicker
                                  color="primary"
                                  fullWidth
                                  inputVariant="outlined"
                                  invalidDateMessage={'Hatalı Tarih Formatı'}
                                  format={'dd.MM.yyyy'}
                                  variant="outlined"
                                  value={baslangicTarihi}
                                  onChange={e => handleDateChange(e, 1)}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={3} title={"Bitiş tarihi"}>
                        <FormControl variant="outlined" className={classes.fields}>
                          <Typography variant="h6" component="h2">
                            <ThemeProvider theme={materialTheme}>
                              <MuiPickersUtilsProvider
                                utils={DateFnsUtils}
                                locale={localeMap['tr']}
                              >
                                <KeyboardDatePicker
                                  color="primary"
                                  fullWidth
                                  inputVariant="outlined"
                                  invalidDateMessage={'Hatalı Tarih Formatı'}
                                  format={'dd.MM.yyyy'}
                                  variant="outlined"
                                  value={bitisTarihi}
                                  onChange={e => handleDateChange(e, 2)}
                                  KeyboardButtonProps={{
                                    'aria-label': 'change date'
                                  }}
                                />
                              </MuiPickersUtilsProvider>
                            </ThemeProvider>
                          </Typography>
                        </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={4}>
                        <Button
                          variant="contained"
                          className={classes.button}
                          color="secondary"
                          endIcon={<SearchIcon></SearchIcon>}
                          onClick={onSorgula}
                        >
                          Sorgula
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={2}>
                        <FormControl fullWidth className={classes.margin}>
                          <TextField
                            label="Arama Yapınız..."
                            value={SayimArama}
                            name={SayimArama}
                            className={clsx(classes.margin, classes.textField)}
                            onChange={event => { setFilter(event.target.value) }}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <SearchIcon />
                                </InputAdornment>
                              )
                            }}
                          />
                        </FormControl>
                      </Grid>
                    </Grid>
                  </CardActions>
                  <Divider />
                  <CardContent>
                    <TableContainer className={classes.container}>
                      <Table
                        className={classes.table}
                        size="small"
                        stickyHeader
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell padding='none' align="left">Durum</TableCell>
                            <TableCell padding='none' align="left">MalzemeStokNo</TableCell>
                            <TableCell padding='none' align="left">Malzeme</TableCell>
                            <TableCell padding='none' align="left">DepoAdet</TableCell>
                            <TableCell padding='none' align="left">AdresAdet</TableCell>
                            <TableCell padding='none' align="left">SayımAdet</TableCell>
                            <TableCell padding='none' align="center" width="200">
                              Adres
                            </TableCell>
                            <TableCell padding='none' align="center">Kullanıcı</TableCell>
                            <TableCell padding='none' align="center">Tarih</TableCell>
                            <TableCell padding='none' align="center">Resim</TableCell>
                            <TableCell padding='none' align="center">Bülten</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {SayimData.sort(
                            (
                              { isEditMode: previousID },
                              { isEditMode: currentID }
                            ) => previousID - currentID
                          )
                            // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row, index) => {
                              const labelId = `enhanced-table-checkbox-${index}`;
                              return (
                                <TableRow
                                  hover
                                  role="checkbox"
                                  tabIndex={-1}
                                  key={index}
                                >
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.DURUM}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME_STOK_NO}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    title={row.MALZEME}
                                    className={classes.tableCell}
                                  >
                                    {row.MALZEME}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.DEPO_ADET}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.ADRES_ADET}
                                  </TableCell>
                                  <TableCell
                                    align="left"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.Count}
                                  </TableCell>
                                  <TableCell padding='none' align="center">
                                    {row.WarehouseAddressText}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.KULLANICI}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    {row.TARIH}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    <ImageSearchIcon
                                      onClick={event =>
                                        GetMaterialImage(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    padding='none'
                                    className={classes.tableCell}
                                  >
                                    <FindInPageIcon
                                      onClick={event =>
                                        GetMaterialBulletin(
                                          event,
                                          row.MALZEME_STOK_NO
                                        )
                                      }
                                      color="primary"
                                    />
                                  </TableCell>
                                </TableRow>
                              );
                            })}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Container>
      <Dialog
        open={bultenOpen}
        onClose={() => setBultenOpen(false)}
        TransitionComponent={Transition}
        keepMounted
      >
        <DialogTitle id="alert-dialog-title">
          Malzemeye Ait Bültenler
        </DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <GenericBulten param={bultenParam} />
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="secondary"
            onClick={() => setBultenOpen(false)}
            className={classes.button}
            endIcon={<CloseIcon>Close</CloseIcon>}
          >
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openMaterialFile}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseMaterialFile}
      >
        <DialogTitle>{openMaterialFileTitle}</DialogTitle>
        <DialogContent>
          {LoadingMaterial ? (
            <LinearProgress status="loading" />
          ) : (
            <img style={{ width: '100%' }} alt="" src={ImageUrl} />
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMaterialFile} color="primary">
            Kapat
          </Button>
        </DialogActions>
      </Dialog>
    </Page>
  );
}

export default Counting;
